package com.trevorwiebe.timesheet.core.domain.model

data class Carrier(
    val id: String,
    val contactName: String,
    val companyName: String = "",
    val address: String = "",
    val phone: String = "",
    val email: String = "",
    val notes: String = "",
    val active: Boolean = true,
    val deleted: Boolean = false,
    val order: Int = 0,
)
